import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UtilService from "../../../../services/Celcoin/utilService";
import { getTranslations } from "../../../../services/languageUtils";

class Step5 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "analise",
      url: "",
      translations: {},
    };
  }

  loadTranslations = async () => {
    const translations = await getTranslations(
      localStorage.getItem("language") || "pt",
    );
    this.setState({ translations });
  };

  componentDidMount() {
    this.loadTranslations();

    try {
      const biometricUrl = sessionStorage.getItem("documentscopys");
      const onboardingStatus = sessionStorage.getItem("onboardingPFStatus");

      this.setState({
        url: biometricUrl || "",
        status: onboardingStatus || "analise",
      });
    } catch (error) {
      console.error("Erro ao carregar status final do onboarding PF:", error);
    }
  }

  logout = () => {
    UtilService.logout();
  };

  renderStatusContent() {
    const { status, translations } = this.state;

    if (status === "aprovado") {
      return (
        <div className="contentAccountStatus">
          <img
            src={require("../../../../assets/imgs/doc-ok.svg").default}
            alt="Status"
            className="statusImage"
          />
          <div className="contentTextStatus">
            <p>
              <b>{translations.accountApproved || "Conta aprovada"}</b>
              <br />
              {translations.firstRemittanceAvailable ||
                "Sua conta foi aprovada e está disponível para uso."}
            </p>

            <div
              className="btnStatus"
              onClick={() => {
                window.location.href = "/user";
              }}
            >
              {translations.makeRemittance || "Acessar conta"}
            </div>
          </div>
        </div>
      );
    }

    if (status === "reprovado") {
      return (
        <div className="contentAccountStatus">
          <img
            src={require("../../../../assets/imgs/doc-reprovado.svg").default}
            alt="Status"
            className="statusImage"
          />
          <div className="contentTextStatus">
            <p>
              <b>{translations.accountRejected || "Cadastro reprovado"}</b>
              <br />
              {translations.contactSupport ||
                "Seu cadastro não foi aprovado. Entre em contato com o suporte para mais informações."}
            </p>

            <div className="btnStatus">
              {translations.contactSupportButton || "Falar com suporte"}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="contentAccountStatus" style={{ justifyContent: "start" }}>
        <img
          src={require("../../../../assets/imgs/doc-ok.svg").default}
          alt="Status"
          className="statusImage"
        />
        <div className="contentTextStatus">
          <p>
            <b>
              {translations.registrationUnderAnalysis ||
                "Cadastro em análise"}
            </b>
            <br />
            {translations.registrationUnderAnalysisDescription ||
              "Recebemos suas informações e sua documentação. Agora o cadastro seguirá para análise de compliance."}
          </p>
        </div>
      </div>
    );
  }

  render() {
    const { translations, url } = this.state;

    return (
      <div className="sideRightContent">
        <div className="textContentSteps">
          <div className="h1">
            <div className="h1Label">
              <img
                src={
                  require("../../../../assets/imgs/ico-higher-titulo.svg")
                    .default
                }
                alt="Logo Higher"
                className="titleImage"
              />
            </div>
            {translations.welcome || "Bem-vindo"}
          </div>
          <br />
          <br />

          <div
            className="contentLabelSucessRegister"
            style={{ display: "flex" }}
          >
            <img
              src={require("../../../../assets/imgs/check-hudge.svg").default}
              alt="Check"
              className="successImage"
            />
            <p style={{ fontSize: "18px" }}>
              <b>
                {translations.informationReceived ||
                  "Recebemos suas informações com sucesso"}
              </b>
            </p>
          </div>

          <div
            className="lineBtnSaveAndContinue"
            style={{ margin: "40px 0px 0px 0px" }}
          ></div>

          <p className="h3AccountStatus" style={{ marginTop: "0px" }}>
            {translations.accountStatusTitle || "Status do cadastro"}
          </p>

          {this.renderStatusContent()}

          <br />

          {url && url !== "null" && (
            <div
              className="lineBtnSaveAndContinue"
              style={{ border: "0px solid white" }}
            >
              <div
                className="btnSaveAndContinue"
                onClick={() => {
                  window.location.href = url;
                }}
              >
                {translations.collectBiometrics || "Coletar biometria"}
              </div>
            </div>
          )}

          <div className="lineBtnSaveAndContinue">
            <div
              className="btnBack"
              onClick={this.logout}
            >
              {translations.logout || "Sair"}
            </div>
          </div>
        </div>

        <ToastContainer />
      </div>
    );
  }
}

export default Step5;
